import React, { useState, useContext } from 'react'
import { Form, FormField, Button, Grommet, Box, Text } from 'grommet'
import theme from '../theme'
import { addIssue } from '../api'
import WaveLoading from '@bit/akameco.styled-spinkit.wave-loading'
import { AppContext } from '../containers/App'

function JiraOps() {
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const appContext = useContext(AppContext)
  const regexp = /(?:\s|^)([A-Z]+-[0-9]+)(?=\s|$)/

  const handleSubmit = async evt => {
    const {
      value: { ticket },
    } = evt
    if (!ticket) {
      setErrorMessage('Enter valid Jira')
    } else {
      const tickets = ticket.match(/(?:\s|^)([A-Z]+-[0-9]+)(?=\s|$)/g)
      try {
        if (tickets) {
          setLoading(true)
          for (const ticket of tickets) {
            await addIssue(ticket.trim())
          }
        }
      } catch {}
      appContext.refetch()
      setLoading(false)
    }
  }

  return (
    <Grommet theme={theme}>
      <Box border={{ color: 'grey' }}>
        <Form onSubmit={handleSubmit}>
          <Box justify="center" margin="small" pad={{ horizontal: 'medium' }}>
            <FormField
              error={errorMessage}
              name="ticket"
              label={<Text size="large">Add new issues to the pool</Text>}
              validate={{ regexp, message: 'Please provide valid Jira ticket' }}
            />
          </Box>
          <Box justify="center" margin={{ bottom: '20px' }}>
            {loading ? (
              <WaveLoading color={theme.global.colors.brand} size={60} style={{ margin: 0 }} />
            ) : (
              <Box pad="60px">
                <Button type="submit" primary label="Add" />
              </Box>
            )}
          </Box>
        </Form>
      </Box>
    </Grommet>
  )
}

export default JiraOps
